// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"fda0d317","309":"7b4f334c","774":"2335af53"}[chunkId] + ".chunk.js";
};